var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 12,
    viewBox: "0 0 161 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.53 6.53033C160.823 6.23744 160.823 5.76256 160.53 5.46967L155.757 0.696699C155.464 0.403806 154.99 0.403806 154.697 0.696699C154.404 0.989593 154.404 1.46447 154.697 1.75736L158.939 6L154.697 10.2426C154.404 10.5355 154.404 11.0104 154.697 11.3033C154.99 11.5962 155.464 11.5962 155.757 11.3033L160.53 6.53033ZM0 6.75H160V5.25H0V6.75Z",
    fill: "url(#paint0_linear_440_1957)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_440_1957",
    x1: 80,
    y1: 6,
    x2: 0,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#395DFB",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#395DFB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.16d247c9f47aefd5999097df2b65cdbc.svg";
export { ForwardRef as ReactComponent };